import { render, staticRenderFns } from "./Videoplayer.html?vue&type=template&id=5d0eab5f&scoped=true&"
import script from "./Videoplayer.vue?vue&type=script&lang=js&"
export * from "./Videoplayer.vue?vue&type=script&lang=js&"
import style0 from "./Videoplayer.scss?vue&type=style&index=0&id=5d0eab5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0eab5f",
  null
  
)

export default component.exports